import { Controller } from "@hotwired/stimulus"
import * as Diff2Html from "diff2html"
import * as Diff from "diff"

// Connects to data-controller="live-diff"
export default class extends Controller {
	static targets = [ "output", "source", "dest"]
	static values = { title: String, sourceMessage: String, destMessage: String, maxLineLengthHighlight: Number }

  connect() {
		this.preview()
  }

  preview() {
		const unifiedDiff = Diff.createPatch(this.titleValue, this.sourceTarget.value, this.destTarget.value, this.sourceMessageValue, this.destMessageValue)

		const diffJson = Diff2Html.parse(unifiedDiff);
		const config = { renderNothingWhenEmpty: false, drawFileList: false, rawTemplates: {"tag-file-renamed": ""} }
		if (this.hasMaxLineLengthHighlightValue) config.maxLineLengthHighlight = this.maxLineLengthHighlightValue
		const diffHtml = Diff2Html.html(diffJson, config);

		this.outputTarget.innerHTML = diffHtml
	}
}
